import { createSimpleExport } from "../../utils/excel/export";
import { MenuAttendanceRowInput } from "../../pages/Auth/Org/MenuAttendance/utils";

interface ExportRow {
  Name: string;
  Team: string;
  Position: string | null;
  Attended: string;
  Time: string;
  "No Matched TWN Athlete": string;
  "No Menu Access": string;
}

type ExportKey = "fullName" | "team" | "position" | "attended" | "time" | "unlisted" | "noAccess";

interface ExportColumnDef {
  header: keyof ExportRow;
  key: ExportKey;
  width: number;
}

export const exportColumns: ExportColumnDef[] = [
  { header: "Name", key: "fullName", width: 20 },
  { header: "Team", key: "team", width: 20 },
  { header: "Position", key: "position", width: 20 },
  { header: "Attended", key: "attended", width: 20 },
  { header: "No Matched TWN Athlete", key: "unlisted", width: 20 },
  { header: "No Menu Access", key: "noAccess", width: 20 },
  { header: "Time", key: "time", width: 20 },
];

interface AttendanceToExcelProps {
  fileName: string;
  rows: MenuAttendanceRowInput[];
}

export const exportAttendanceToExcel = async ({ fileName, rows }: AttendanceToExcelProps) => {
  const serializedRows = rows.map(({ fullName, teamName: team, position, checkInDisplayDate, checkedIn, unlisted, hasAccess }) => ({
    fullName,
    team,
    position,
    time: checkInDisplayDate || "",
    attended: checkedIn ? "x" : "",
    unlisted: unlisted ? "x" : "",
    noAccess: !hasAccess && !unlisted ? "x" : "",
  }));
  await createSimpleExport({
    columns: exportColumns,
    rows: serializedRows,
    fileName,
    options: { centerHeaders: true, freezeHeader: true },
  });
};
